exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/vue-slider-component/theme/default.css"), "");

// module
exports.push([module.id, ".related-module[data-v-5fc39eba]{background-color:#4baf4d!important;margin-right:3px}.related-module[data-v-5fc39eba]:hover{background-color:green!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5fc39eba&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/grid/RelatedModulesComponent.vue
// module id = 899
// module chunks = 2